import React, { memo } from 'react';
import { iconUrl, iconWebp } from '../utils/assets';

/**
 * <img> for anything out of /assets/icons.
 *
 * The art ships as both PNG and WebP, so this renders a <picture> and lets the
 * WebView pick: modern ones take the WebP (a quarter of the bytes, and the
 * sticker loops decode a quarter of the pixels), anything older still gets the
 * original PNG. Same artwork either way — only the encoding differs.
 */
const IconImg = memo(function IconImg({
  src,
  alt = '',
  still = false,
  small = false,
  className = '',
  ...rest
}) {
  const png = iconUrl(src);
  const webp = iconWebp(src, { still, small });

  return (
    <picture>
      {webp ? <source srcSet={webp} type="image/webp" /> : null}
      <img src={png} alt={alt} className={className} {...rest} />
    </picture>
  );
});

export default IconImg;
